import { useCallback } from 'react';
import { PresentationBlock } from 'shared/components/PresentationBlock';
import { MortgageWrapperIdName } from 'shared/constants/common';
import { useTracking } from '../../utils/tracking/useTracking';

export const PresentationBlockContainer = () => {
  const { trackClickOnTargetButton } = useTracking();

  const onScrollToMortgageBlock = useCallback(() => {
    trackClickOnTargetButton();
    const element = document.getElementById(MortgageWrapperIdName);
    element?.scrollIntoView({
      behavior: 'smooth',
    });
  }, []);

  return (
    <PresentationBlock
      title={'Подберите свою ипотеку'}
      description={'Льготные программы, эксклюзивы, акции от застройщиков — всё здесь'}
      handleClickButton={onScrollToMortgageBlock}
    />
  );
};
